import { ref } from 'vue';

// Module-level refs (singleton) so the event captured at app load
// survives even if the menu component mounts after beforeinstallprompt fires.
const deferredPrompt = ref(null);
const canInstall = ref(false);

// Register listeners at module-load time — this is the most robust approach
// for catching the early-fired beforeinstallprompt event (fires shortly after
// page load, before most components mount).
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault();
    deferredPrompt.value = e;
    canInstall.value = true;
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt.value = null;
    canInstall.value = false;
  });
}

export function usePwaInstall() {
  const promptInstall = async () => {
    if (!deferredPrompt.value) return false;
    deferredPrompt.value.prompt();
    const choice = await deferredPrompt.value.userChoice;
    deferredPrompt.value = null;
    canInstall.value = false;
    return choice?.outcome === 'accepted';
  };

  return { canInstall, promptInstall };
}
